export class TotalSourceStorageSizeRequest {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "filter",
            "baseName": "filter",
            "type": "Condition",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return TotalSourceStorageSizeRequest.attributeTypeMap;
    }
    constructor() {
    }
}
